import { projectClient } from '../../client/client';

export const messaging = {
  getMessagingConfig: projectClient('/messaging/config').get,
};
